import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { Loader2 } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const sessionId = location.hash.split("session_id=")[1]?.split("&")[0];
    axios
      .post(`${API}/auth/session`, { session_id: sessionId }, { withCredentials: true })
      .then((res) => navigate("/", { state: { user: res.data }, replace: true }))
      .catch(() => navigate("/", { replace: true }));
  }, [location.hash, navigate]);

  return (
    <div data-testid="auth-callback" className="flex min-h-screen items-center justify-center bg-[#050505]">
      <Loader2 className="h-8 w-8 animate-spin text-[#FF3B30]" aria-hidden />
    </div>
  );
}
